import React from "react";
import styles from "./styles.css";
import CarHistoryReportModalFormWrapper from "../car-history-report-modal-form-wrapper";
import PropTypes from "prop-types";
import { PAGE_SOURCE } from "../../../constants/app-constants";
import routesConstant from "../../../constants/routes-constant";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { CHR_GA_EVENTS } from "../car-history-report-landing-page/tracking";
import { getStyles } from "./constants";
import { withRouter } from "react-router-dom";
import Button from "../../shared/button";

const SellLandingPageCarTrustTopBanner = ({
    showCarHistoryFlowInitModal,
    updateShowCarHistoryFlowInitModalConnect,
    pageSection,
    pageSource,
    match: {
        params: {
            lid: carId
        }
    }
}) => {
    const handleShowCarHistoryFlowInitModal = async () => {
        if (pageSource === PAGE_SOURCE.SELL_VALUATION_PAGE) {
            updateShowCarHistoryFlowInitModalConnect(true);
        } else {
            let url = routesConstant.car_history_report;
            if (pageSource === PAGE_SOURCE.CDP) {
                url = `${url}?lid=${carId}`;
            }
            window.open(url, "_blank");
        }
        trackDesktopCustomEventsAU(CHR_GA_EVENTS.CHR_ENTRY_POINT_CLICKED, {
            ...CHR_GA_EVENTS.CHR_ENTRY_POINT_CLICKED,
            eventCategory: pageSource
        });
    };

    const handleModalClose = () => {
        updateShowCarHistoryFlowInitModalConnect(false);
    };

    const {wrapperStyle, textStyle, contentWrapStyle, outerStyle} = getStyles(pageSource);
    return (
        <div className={pageSource === PAGE_SOURCE.SELL_PAGE ? "container" : ""}>
            <div styleName={`styles.defaultOuter ${outerStyle}`}>
                <img src={pageSection?.meta?.image} />
                <div styleName={`styles.defaultContentWrap ${contentWrapStyle}`}>
                    <div styleName={`styles.defaultWrapper ${wrapperStyle}`}>
                        <img src={pageSection?.meta?.logo} />
                        <p styleName={`styles.defaultText ${textStyle}`}>{pageSection?.meta?.text}</p>
                        <p styleName={`styles.defaultSubText`}>{pageSection?.meta?.subtext || "Show a clean, verified car history and negotiate with confidence"}</p>
                    </div>
                    <Button variant="tertiary" size="large" onClick={handleShowCarHistoryFlowInitModal} text={pageSection?.meta?.cta?.text}/>
                </div>
                {
                    showCarHistoryFlowInitModal && (
                        <CarHistoryReportModalFormWrapper handleCloseForm={handleModalClose}/>
                    )
                }
            </div>
        </div>
    );
};

SellLandingPageCarTrustTopBanner.propTypes = {
    showCarHistoryFlowInitModal: PropTypes.bool,
    updateShowCarHistoryFlowInitModalConnect: PropTypes.func.isRequired,
    source: PropTypes.string,
    pageSection: PropTypes.object,
    pageSource: PropTypes.string,
    match: PropTypes.object
};

export default withRouter(SellLandingPageCarTrustTopBanner);
